<template>
	<layer class="opt_more_g" name="week">
		<div class="box_opt_menu list_week_type">
			<div class="menu_item" v-for="{key, value} in weeks">
				<a href="javascript:" class="link_menu" @click="callback(key)">{{ value }}</a>
			</div>
		</div>
	</layer>
</template>

<script>
import Layer from './Layer.vue';

export default {
	components: {Layer},
	props: {
		weeks: {
			type: Array,
			default: () => ([])
		},
		callback: {
			type: Function,
			default: () => null
		}
	}
}
</script>
